import {Component} from "../../../../../../../sedestral/framework/interface/component/Component";
import * as s from "./website-black-testimonial-results.scss";
import {Resources} from "../../../../../../../resources/Resources";

export class WebsiteBlackTestimonialResultsComponent extends Component {
    //language=HTML
    constructor(cases: { title: string, description: string, image: string }[]) {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteBlackTestimonialResults}">
                <h3 class="${s.title}">
                    ${Resources.t("words.testimonialResults")}
                    <div class="${s.icon}"></div>
                </h3>
                <div class="${s.cases}">
                    ${cases.map(value => `
                    <div class="${s.case}">
                        <div class="${s.name}">
                            <h4>${value.title}</h4>
                        </div>
                        <p class="${s.description}">
                            ${value.description}
                        </p>
                        <img class="${s.image}" alt="${value.title}" src="${value.image}"/>
                    </div>
                    `).join("")}
                </div>
            </div>
        `;
    }
}